<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="境界立会申請件名詳細編集"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll :leftSpan="24">
          <template #left>
            <boundary-info
              v-if="requestHeaderId"
              :requestHeaderId="requestHeaderId"
              @update:form="detail = $event"
              mode="edit"
            />
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import { useRoute, useRouter } from 'vue-router'
import { RequestHeaderBoundaryDetailForm } from '@/types/forms'
import Logger from '@/services/logger'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'

/**
 * 境界立会申請件名詳細編集
 */
export default defineComponent({
  name: 'BoundaryEdit',
  components: {
    UserLoginWrapper,
    BoundaryInfo,
    DoubleScroll,
    JrApplicantTitle,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })
    if (!requestHeaderId.value) {
      Logger.info('URLパラメータが不正です。')
      router.push({ name: 'NotFound' })
    }
    const detail = ref<RequestHeaderBoundaryDetailForm | null>(null)

    return {
      requestHeaderId,
      detail,
    }
  },
})
</script>
